import { render, staticRenderFns } from "./_filter_list_for_tags.vue?vue&type=template&id=0bf487b2&scoped=true&"
import script from "./_filter_list_for_tags.vue?vue&type=script&lang=js&"
export * from "./_filter_list_for_tags.vue?vue&type=script&lang=js&"
import style0 from "./_filter_list_for_tags.vue?vue&type=style&index=0&id=0bf487b2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf487b2",
  null
  
)

export default component.exports